import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newLine',
  standalone: false,
})
export class NewLinePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return value.replace('\n', '<br/>').replace(/#CR/g, '<br/>');
  }
}
